import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PreferencesService } from '@services/preferences.service';
import { HistoryService } from '@services/history.service';
import { ConnectionMonitorService } from '@services/connection-monitor.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  title = 'MealCheck-Caisse';

  private translate = inject(TranslateService);
  private prefs = inject(PreferencesService);
  private readonly historyService = inject(HistoryService);
  private readonly connectionMonitor = inject(ConnectionMonitorService);

  ngOnInit(): void {
    this.initLanguage();
    this.subscribePreferences();
    this.connectionMonitor.start();
  }

  private initLanguage(): void {
    // Appliquer la langue préférée au démarrage
    const currentLang = this.prefs.getPreferencesSnapshot().language;
    if (currentLang) {
      this.translate.use(currentLang);
    }
  }

  private subscribePreferences(): void {
    // Écouter les changements de préférences (notamment la langue)
    this.prefs.prefs$.subscribe((p) => {
      if (p && p.language) {
        this.translate.use(p.language);
      }

      this.applyTextPreferences(p);
    });
  }

  private applyTextPreferences(prefs: any) {
    if (!prefs) return;
    const root = document.documentElement;

    // Classe pour texte en gras
    if (prefs.boldText) {
      root.classList.add('pref-bold-text');
    } else {
      root.classList.remove('pref-bold-text');
    }

    // Classe pour texte en majuscule
    if (prefs.uppercaseText) {
      root.classList.add('pref-uppercase-text');
    } else {
      root.classList.remove('pref-uppercase-text');
    }

    // Classe pour mode dyslexie
    if (prefs.dyslexicMode) {
      root.classList.add('pref-dyslexic-mode');
    } else {
      root.classList.remove('pref-dyslexic-mode');
    }
  }
}
